<!-- tieto 4 prvky su z dialogu rozvrhove-akcie-component.html -->
  <!-- CLOSE BUTTON -->
<button type="button" class="close-button me-1" mat-icon-button mat-dialog-close
   aria-label="Close">
   <!-- <span aria-hidden="true">&times;</span> -->
    <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h2 class="d-none d-sm-block text-black-50 pt-2 mb-3"
  [ngClass]="{'ms-2': uzsiLavyOkraj, 'ms-3': !uzsiLavyOkraj}">
  <span>{{titulok}}</span>
</h2>
<!-- zobrazenie na mobile -->
<h2 class="d-block d-sm-none text-black-50 ms-2 pt-2 mb-2">
  <span>{{titulok}}</span>
</h2>

<!-- vetva pre skupinu predmetov-->
<ng-container *ngIf="skratkyANazvyPredmetov; else jedenPredmet">
  <!-- vetva pre jeden predmet zo skupiny -->
  <ng-container *ngIf="skratkyANazvyPredmetov.length === 1;else viacPredmetov">
    <h2 *ngFor="let predmet of skratkyANazvyPredmetov; index as i"
      class="d-none d-sm-block ms-3 mb-0">
      <span i18 matTooltip="Názov predmetu">
        {{predmet[1]}}
      </span>
      <span i18 matTooltip="Skratka predmetu" class="text-black-50 ms-1">
        {{predmet[0]}}
      </span>
    </h2>
  </ng-container>
  <!-- vetva pre viac predmetov zo skupiny -->
  <ng-template #viacPredmetov>
    <h3 *ngFor="let predmet of skratkyANazvyPredmetov; index as i"
      class="d-none d-sm-block ms-3 mb-0">
      <span i18 matTooltip="Názov predmetu">
        {{predmet[1]}}
      </span>
      <span i18 matTooltip="Skratka predmetu" class="text-black-50 ms-1">
        {{predmet[0]}}
      </span>
    </h3>
  </ng-template>
  <!-- mobil -->
  <h3 *ngFor="let predmet of skratkyANazvyPredmetov; index as i"
    class="d-block d-sm-none ms-2 mb-0">
    <span i18 matTooltip="Názov predmetu">
      {{predmet[0]}}
    </span>
    -
    <span i18 matTooltip="Skratka predmetu" class="text-black-50">
      {{predmet[1]}}
    </span>
  </h3>
</ng-container>
<!-- vetva pre jeden predmet-->
<ng-template #jedenPredmet>
  <h2 *ngIf="predmetNazov || predmetSkratka || predmetRozsah"
    class="d-none d-sm-block"
    [ngClass]="{'mb-0': doplnujuciText, 'ms-2': uzsiLavyOkraj, 'ms-3': !uzsiLavyOkraj}">
    <span i18 matTooltip="Názov predmetu">{{predmetNazov}} </span>
    <span i18 matTooltip="Skratka predmetu" class="text-black-50"> {{predmetSkratka}}</span>
    <span i18 matTooltip="Rozsah predmetu" class="ms-3 text-black-50">{{predmetRozsah}}</span>
  </h2>
  <h3 *ngIf="doplnujuciText"
    class="d-none d-sm-block ms-3">
    <span i18>{{doplnujuciText}} </span>
  </h3>
  <!-- zobrazenie na mobile -->
  <div class="d-block d-sm-none ms-2">
    <h3 *ngIf="predmetNazov || predmetSkratka || predmetRozsah">
      {{predmetSkratka}} - {{predmetNazov}}
      <span *ngIf="predmetRozsah" class="ms-2 text-black-50">{{predmetRozsah}}</span>
    </h3>
    <h5 *ngIf="doplnujuciText">
      <span i18>{{doplnujuciText}} </span>
    </h5>
  </div>
</ng-template>

<hr/>


